import { useEffect } from 'react';
import { useSolicitudCoberturaTramitesPorDelegacionData } from '../hooks';
import { AutorizadoAnualBarra, IniciadoAnualBarra, IniciadoAutorizadoAnualBarraApilada } from '../components';
import { Grid } from '@mui/material';

const initData = {
  idDivision: 5,
  idTipoCobertura: 166,
};

export const SolicitudCoberturaTramitesPorDelegacion = () => {
  const { fechaAnioActual, getTramitesPorDelegacionAnualList, tramitesPorDelegacionAnualList } =
    useSolicitudCoberturaTramitesPorDelegacionData({
      ...initData,
    });

  useEffect(() => {
    getTramitesPorDelegacionAnualList();
  }, []);

  return (
    <>
      <Grid item xs={12} md={6}>
        <IniciadoAnualBarra date={fechaAnioActual} data={tramitesPorDelegacionAnualList} />
      </Grid>
      <Grid item xs={12} md={6}>
        <AutorizadoAnualBarra date={fechaAnioActual} data={tramitesPorDelegacionAnualList} />
        {/* <IniciadoAutorizadoAnualBarraApilada
          date={fechaAnioActual}
          data={tramitesPorDelegacionAnualList}
        /> */}
      </Grid>
    </>
  );
};
